export default "/fonts/vendor/katex/dist/KaTeX_SansSerif-Italic.woff2?7d393d382f3e7fb1c637280a90a3434b";